import React, { useState } from 'react';
import {
  Box,
  Heading,
  Input,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Text,
  VStack,
  FormControl,
  FormLabel,
  Textarea,
  Button,
  useToast,
  HStack,
} from '@chakra-ui/react';
import {
  FaUserFriends,
  FaCalendarAlt,
  FaMoneyBillWave,
  FaCogs,
  FaHandsHelping,
  FaLifeRing,
} from 'react-icons/fa';

// Categorie FAQ con icone
const faqSections = [
  {
    category: 'Tesseramento e Soci',
    icon: <FaUserFriends />,
    faqs: [
      {
        question: 'Come posso diventare socio dell’associazione?',
        answer:
          'Registrati sul nostro sito cliccando su "Tesseramento" nel menu principale. Il tesseramento permette di partecipare alle attività riservate ai soci e offre una copertura assicurativa.',
      },
      {
        question: 'Qual è il costo del tesseramento e quanto dura la tessera?',
        answer:
          'Il costo del tesseramento è di 10€ ed è valido fino al 31 dicembre dell’anno in corso. Se ti tessi dopo il 1° novembre, la tessera sarà valida anche per l’anno successivo.',
      },
      {
        question: 'Posso tesserarmi in qualsiasi momento dell’anno?',
        answer:
          'Sì, puoi tesserarti quando vuoi e dove vuoi! Se ti iscrivi dopo il 1° novembre, la tessera varrà anche per l’anno successivo.',
      },
      {
        question: 'Posso partecipare a un evento se la mia tessera è scaduta?',
        answer:
          'No, per partecipare agli eventi è necessaria una tessera associativa valida. Puoi però rinnovarla facilmente prima dell’evento per continuare a partecipare alle attività.',
      },
      {
        question: 'Cosa succede se perdo la mia tessera associativa?',
        answer:
          'Nessun problema! Passa in sede e te ne forniremo subito un’altra.',
      },
      {
        question: 'Come posso sapere se il mio tesseramento è ancora valido?',
        answer:
          'Tutte le tessere scadono il 31 dicembre dell’anno in corso. Se hai dubbi, controlla il tuo account o contattaci.',
      },
      {
        question: 'Posso rinnovare la tessera prima della scadenza?',
        answer:
          'No, il rinnovo può essere effettuato solo dopo la scadenza della tessera, a partire dal 1° gennaio dell’anno successivo.',
      },
      {
        question: 'Se smetto di essere socio, la mia tessera rimane valida?',
        answer:
          'No, se decidi di non essere più socio, la tua tessera perderà validità e non potrai più partecipare alle attività riservate ai soci.',
      },
      {
        question: 'C’è un’età minima o massima per tesserarsi?',
        answer:
          'No, non c’è! Un utente può tesserare quanti minori vuole, ma per ogni email è possibile registrare un solo socio maggiorenne.',
      },
      {
        question: 'Posso usare la stessa email per più soci maggiorenni?',
        answer:
          'No, ogni socio maggiorenne deve avere un’email unica per la registrazione.',
      },
      {
        question: 'Posso modificare l’email associata al mio account?',
        answer:
          'No, l’email associata al tuo account non può essere modificata. Se hai bisogno di supporto, contattaci.',
      },
      {
        question: 'Come posso eliminare il mio account e i miei dati?',
        answer:
          'Contattaci e provvederemo a rimuovere i tuoi dati dal sistema nel rispetto della normativa sulla privacy.',
      },
      {
        question:
          'Posso sospendere temporaneamente la mia iscrizione senza eliminarla?',
        answer:
          'No, l’iscrizione non può essere sospesa temporaneamente. Se hai bisogno di supporto, contattaci.',
      },
      {
        question:
          'Cosa succede se dimentico di rinnovare la tessera entro la scadenza?',
        answer:
          'Non potrai partecipare alle attività e agli eventi riservati ai soci fino a quando non effettuerai un nuovo tesseramento.',
      },
      {
        question: 'Posso tesserarmi direttamente in sede?',
        answer:
          'Sì, ma dovrai comunque farlo dal sito! Abbiamo scelto di ridurre l’uso della carta, quindi l’iscrizione avviene solo in formato digitale.',
      },
      {
        question: 'Posso pagare la tessera in contanti?',
        answer:
          'Certo! Puoi pagare la tessera in contanti, oltre che con bonifico, POS, Satispay o PayPal.',
      },
      {
        question: 'Cosa include il costo del tesseramento?',
        answer:
          'Il costo del tesseramento include: copertura assicurativa per le attività dell’associazione, tessera cartacea da ritirare in sede o all’evento e accesso alle attività riservate ai soci.',
      },
      {
        question: 'La tessera dà diritto a sconti o vantaggi extra?',
        answer:
          'Sì! Gli sconti dei partner compaiono nei piani CIL+ e nelle comunicazioni ai soci. Se hai un’attività e vuoi collaborare come sponsor, visita la pagina /sponsor sul sito.',
      },
      {
        question:
          'Posso partecipare alle attività se non ho ancora ricevuto la tessera fisica?',
        answer:
          'Certo! Basta aver pagato la quota associativa. Potrai ritirare la tua tessera in sede o direttamente all’evento.',
      },
      {
        question:
          'Posso richiedere un rimborso dopo aver pagato la quota associativa?',
        answer:
          'No, la quota associativa non è rimborsabile. Puoi comunque decidere di non far più parte di CIL.',
      },
    ],
  },
  {
    category: 'Eventi e Attività',
    icon: <FaCalendarAlt />,
    faqs: [
      {
        question: 'È necessario prenotarsi per partecipare agli eventi?',
        answer:
          'Sì, per partecipare agli eventi è necessario prenotarsi sul sito. Basta cliccare sull’evento desiderato e seguire le istruzioni premendo il tasto "Partecipa".',
      },
      {
        question: 'Gli eventi sono aperti solo ai soci?',
        answer:
          'Salvo rare eccezioni, le attività dell’associazione sono riservate ai soci.',
      },
      {
        question:
          'Come posso sapere se un evento è riservato ai soci o aperto a tutti?',
        answer:
          'Se non diversamente specificato, gli eventi sono riservati ai soci. Puoi utilizzare il filtro sul sito per visualizzare solo gli eventi aperti a tutti.',
      },
      {
        question:
          'Cosa succede se un evento viene annullato dall’associazione?',
        answer:
          'Se l’evento viene annullato dall’associazione, i partecipanti potranno scegliere tra un rimborso completo della quota di iscrizione o la possibilità di partecipare a un’attività futura dell’associazione.',
      },
      {
        question:
          'Cosa succede se l’evento subisce modifiche di data o orario?',
        answer:
          'Diamo sempre la possibilità di rinunciare all’evento se l’associazione cambia le condizioni. Cerchiamo di offrire soluzioni semplici e vantaggiose per il socio.',
      },
      {
        question:
          'Cosa succede se mi iscrivo a un evento ma poi non posso più partecipare?',
        answer:
          'Non succede nulla di grave, ma non possiamo garantire il rimborso perché la tua quota potrebbe essere già stata utilizzata per coprire i costi dell’evento.',
      },
      {
        question: 'Posso annullare una prenotazione a un evento?',
        answer:
          'Per annullare una prenotazione, contattaci tramite telefono o email il prima possibile.',
      },
      {
        question: 'Cosa succede se arrivo in ritardo a un evento?',
        answer:
          'Nessun problema! Noi cominciamo all’orario previsto, ma potrai unirti appena arrivi.',
      },
      {
        question: 'Posso partecipare a un evento senza essermi prenotato?',
        answer:
          'Salvo rare occasioni, sconsigliamo vivamente di presentarsi senza prenotazione.',
      },
      {
        question: 'Gli eventi hanno un numero minimo di partecipanti?',
        answer:
          'Dipende dall’evento. Ti consigliamo di consultare i dettagli dell’evento specifico sul nostro sito.',
      },
      {
        question: 'Posso iscrivermi a più eventi contemporaneamente?',
        answer:
          'Certo! Puoi iscriverti a più eventi contemporaneamente, purché rispettino le condizioni di partecipazione.',
      },
      {
        question: 'Posso portare un accompagnatore a un evento?',
        answer: 'Sì, ma deve effettuare la prenotazione anche lui.',
      },
      {
        question: 'Gli eventi sono accessibili a persone con disabilità?',
        answer:
          'Dipende dall’evento. Ti invitiamo a contattarci per avere maggiori informazioni sull’accessibilità e sulle eventuali soluzioni disponibili per garantire la partecipazione.',
      },
      {
        question: 'Cosa devo fare se ho un problema il giorno dell’evento?',
        answer:
          'In caso di problemi il giorno dell’evento, contatta tempestivamente l’associazione tramite telefono per ricevere assistenza.',
      },
      {
        question: 'Posso trasferire la mia iscrizione a un’altra persona?',
        answer:
          'No, salvo motivi precedentemente concordati e approvati dal direttivo.',
      },
      {
        question:
          'Come posso proporre un’attività o un progetto all’associazione?',
        answer:
          'Puoi proporre un’attività o un progetto compilando il form nella sezione "Contattaci" sul nostro sito. Seleziona l’opzione "Proposta progetto" nel menu a tendina e descrivi la tua idea. Il nostro team la valuterà e ti ricontatterà.',
      },
      {
        question: 'Posso regalare un tesseramento o un’attività a qualcuno?',
        answer:
          'Che bella idea! 🎁 Contattaci per comunicarci i dettagli e saremo felici di aiutarti a fare questo regalo speciale!',
      },
    ],
  },
  {
    category: 'Pagamenti e Rimborsi',
    icon: <FaMoneyBillWave />,
    faqs: [
      {
        question: 'Quali sono i metodi di pagamento accettati?',
        answer: 'Accettiamo contanti, bonifico, POS, Satispay, PayPal e carta.',
      },
      {
        question: 'Posso pagare la tessera in contanti?',
        answer:
          'Certo! Puoi pagare la tessera in contanti, oltre che con bonifico, POS, Satispay o PayPal.',
      },
      {
        question:
          'Posso richiedere una ricevuta per il pagamento del tesseramento o degli eventi?',
        answer:
          'Assolutamente sì! Contattaci per ricevere la tua ricevuta. A breve sarà possibile scaricarla direttamente dal proprio account utente sul sito.',
      },
      {
        question: 'Cosa succede se un pagamento online non va a buon fine?',
        answer:
          'Dipende dal tipo di errore. Se il pagamento non va a buon fine, prova a ripetere l’operazione. Se il problema persiste, contattaci e ti aiuteremo a risolverlo.',
      },
      {
        question:
          'Cosa succede se decido di non partecipare a un evento dopo essermi iscritto?',
        answer:
          'Non succede nulla di grave, ma non possiamo garantire il rimborso perché la tua quota potrebbe essere già stata utilizzata per coprire i costi dell’evento.',
      },
      {
        question:
          'Cosa succede se un evento viene annullato dall’associazione?',
        answer:
          'Se l’evento viene annullato dall’associazione (ad esempio, per mancato raggiungimento del numero minimo di partecipanti o per cause di forza maggiore), i partecipanti potranno scegliere tra un rimborso completo della quota di iscrizione o la possibilità di partecipare a un’attività futura dell’associazione.',
      },
      {
        question:
          'Posso ricevere un rimborso se non posso più partecipare a un evento?',
        answer:
          'No, le quote di partecipazione non sono rimborsabili se il partecipante decide di non presentarsi all’evento per motivi personali.',
      },
      {
        question: 'Come posso sapere quando la mia tessera scade?',
        answer:
          'Tutte le tessere scadono il 31 dicembre dell’anno in corso. Se ti sei tesserato dopo il 1° novembre, la tua tessera sarà valida anche per l’anno successivo.',
      },
    ],
  },
  {
    category: 'Utilizzo del Sito',
    icon: <FaCogs />,
    faqs: [
      {
        question: 'Come posso registrarmi al sito?',
        answer:
          'Per registrarti, vai sulla pagina di tesseramento e segui le istruzioni. Una volta completata la registrazione, potrai accedere con le tue credenziali.',
      },
      {
        question: 'Ho dimenticato la password, come posso recuperarla?',
        answer:
          'Clicca su "Login" e poi su "Ho dimenticato la password". Ti invieremo un link per resettarla.',
      },
      {
        question: 'Cosa devo fare se non ricevo l’email di recupero password?',
        answer:
          'Controlla nella cartella spam! Se non trovi l’email, contattaci e ti aiuteremo a recuperare l’accesso al tuo account.',
      },
      {
        question: 'Posso modificare l’email associata al mio account?',
        answer:
          'No, l’email associata al tuo account non può essere modificata. Se hai bisogno di supporto, contattaci.',
      },
      {
        question: 'Come posso aggiornare i miei dati personali?',
        answer:
          'Puoi aggiornare i tuoi dati personali nella sezione "Il mio account".',
      },
      {
        question: 'Posso eliminare il mio account e i miei dati?',
        answer:
          'Contattaci e provvederemo a rimuovere i tuoi dati dal sistema nel rispetto della normativa sulla privacy.',
      },
      {
        question:
          'Posso sospendere temporaneamente la mia iscrizione senza eliminarla?',
        answer:
          'No, l’iscrizione non può essere sospesa temporaneamente. Se hai bisogno di supporto, contattaci.',
      },
      {
        question: 'Dove posso trovare le informazioni sugli eventi?',
        answer:
          'Puoi consultare la sezione "Eventi" del sito per visualizzare tutte le attività in programma.',
      },
      {
        question: 'Dove posso vedere gli eventi a cui sono iscritto?',
        answer:
          'Puoi trovare la lista degli eventi a cui sei iscritto nella sezione "Ordini" del tuo account.',
      },
      {
        question:
          'Come posso sapere se un evento è riservato ai soci o aperto a tutti?',
        answer:
          'Se non diversamente specificato, gli eventi sono riservati ai soci. Puoi utilizzare il filtro sul sito per trovare gli eventi aperti a tutti.',
      },
      {
        question: 'C’è un calendario con tutti gli eventi disponibili?',
        answer:
          'Sì, puoi trovare il calendario completo nella sezione "Eventi" del sito.',
      },
      {
        question: 'Posso ricevere notifiche sugli eventi o sulle novità?',
        answer:
          'No, non inviamo notifiche automatiche via email o sul sito. Ti consigliamo di seguire i nostri canali social per gli aggiornamenti e di controllare la sezione "Il mio account" o la lista eventi per sapere quali sono i prossimi eventi a cui sei iscritto.',
      },
      {
        question: 'Il sito non si carica correttamente, cosa posso fare?',
        answer:
          'Prova a ricaricare la pagina o a cambiare browser. Se il problema persiste, contattaci.',
      },
      {
        question:
          'Non riesco a completare la registrazione, come posso risolvere?',
        answer:
          'Se riscontri problemi con la registrazione, contattaci e ti aiuteremo a completare la procedura.',
      },
      {
        question: 'Non ricevo le email dal sito, cosa devo fare?',
        answer:
          'Controlla nella cartella spam. Se il problema persiste, contattaci per verificare che l’email inserita sia corretta.',
      },
      {
        question: 'Come posso sapere quando scade la mia tessera?',
        answer:
          'Tutte le tessere scadono il 31 dicembre dell’anno in corso. Se ti sei tesserato dopo il 1° novembre, la tua tessera sarà valida anche per l’anno successivo.',
      },
    ],
  },
  {
    category: 'Collaborazioni e Volontariato',
    icon: <FaHandsHelping />,
    faqs: [
      {
        question:
          'Posso diventare volontario e aiutare nelle attività dell’associazione?',
        answer:
          'Assolutamente sì! Il tuo aiuto è prezioso. Se vuoi diventare volontario, passa in sede o scrivici per scoprire come dare il tuo contributo.',
      },
      {
        question:
          'Ci sono opportunità di collaborazione per altre associazioni o enti?',
        answer:
          'Siamo sempre alla ricerca di nuove collaborazioni per portare avanti la nostra missione e gli obiettivi sociali dell’associazione. Se rappresenti un’associazione o un ente e vuoi collaborare con noi, contattaci per discuterne insieme!',
      },
      {
        question:
          'Come posso proporre un’attività o un progetto all’associazione?',
        answer:
          'Puoi proporre un’attività o un progetto compilando il form nella sezione "Contattaci" sul nostro sito. Seleziona l’opzione "Proposta progetto" nel menu a tendina e descrivi la tua idea. Il nostro team la valuterà e ti ricontatterà.',
      },
    ],
  },
  {
    category: 'Assistenza e Contatti',
    icon: <FaLifeRing />,
    faqs: [
      {
        question:
          'Come posso contattare l’associazione per ulteriori informazioni?',
        answer:
          'Puoi contattarci in diversi modi:\n- **Modulo "Contattaci"** sul nostro sito.\n- **Telefono**: chiamandoci direttamente.\n- **Email**: scrivendoci alla nostra casella di posta.\n- **Social media**: tramite **Facebook** e **Instagram**.',
      },
      {
        question: 'Dove si trova la sede dell’associazione?',
        answer:
          'Le attività dell’associazione si svolgono nella nostra sede operativa in **Via Carlo Alberto 7, Chieri (TO)**. La sede legale, invece, è in **Via GB Buschetti 18, Chieri (TO)**.',
      },
      {
        question: 'Posso tesserarmi direttamente in sede?',
        answer:
          'Sì, ma dovrai comunque completare la procedura online dal sito! Abbiamo scelto di ridurre l’uso della carta, quindi l’iscrizione avviene solo in formato digitale. Se hai bisogno di aiuto, possiamo assisterti in sede.',
      },
      {
        question: 'Cosa devo fare se ho un problema tecnico sul sito?',
        answer:
          'Puoi contattarci tramite il **modulo "Contattaci"** sul sito, selezionando l’opzione **"Problema tecnico"** dal menu a tendina. Ti risponderemo il prima possibile per aiutarti a risolvere il problema.',
      },
      {
        question: 'Cosa devo fare se ho un problema il giorno dell’evento?',
        answer:
          'In caso di problemi il giorno dell’evento, contatta tempestivamente l’associazione tramite **telefono** per ricevere assistenza.',
      },
      {
        question:
          'Non ho trovato la risposta alla mia domanda, come posso fare?',
        answer:
          'Se non hai trovato la risposta che cercavi, contattaci direttamente tramite il modulo di contatto sul sito o scrivici sui nostri canali social. Saremo felici di aiutarti!',
      },
    ],
  },
];

// Componente FAQ
const FAQPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSending, setIsSending] = useState(false);
  const toast = useToast();

  const filteredSections = faqSections.map((section) => ({
    ...section,
    faqs: section.faqs.filter((faq) =>
      faq.question.toLowerCase().includes(searchQuery.toLowerCase())
    ),
  }));

  const handleContactSubmit = (e) => {
    e.preventDefault();
    setIsSending(true);

    setTimeout(() => {
      toast({
        title: 'Messaggio inviato!',
        description: 'Ti risponderemo il prima possibile.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
      setEmail('');
      setMessage('');
      setIsSending(false);
    }, 1500);
  };

  return (
    <Box p={8}>
      {/* Titolo */}
      <Heading as="h1" mb={6} textAlign="center" color="gray.700">
        Domande Frequenti (FAQ)
      </Heading>

      {/* Sezione descrittiva */}
      <Box bg="white" p={6} borderRadius="md" boxShadow="md">
        <Text fontSize="lg" mb={4} textAlign="center">
          Benvenuto nella nostra sezione FAQ! Qui troverai le risposte alle
          domande più comuni sulla nostra associazione, sulle attività e sul
          funzionamento del sito.
        </Text>

        <VStack align="center">
          <HStack>
            <Box color="teal.500">💡</Box>
            <Text>
              <strong>Come funziona?</strong>
            </Text>
          </HStack>

          <HStack>
            <Box color="teal.500">✔</Box>
            <Text>
              Le domande sono suddivise in <strong>categorie</strong> per
              aiutarti a trovare facilmente ciò che cerchi.
            </Text>
          </HStack>

          <HStack>
            <Box color="teal.500">✔</Box>
            <Text>
              Usa la <strong>barra di ricerca</strong> per filtrare rapidamente
              le risposte.
            </Text>
          </HStack>

          <HStack>
            <Box color="teal.500">✔</Box>
            <Text>
              Se non trovi quello che ti serve, puoi sempre contattarci tramite
              il <strong>form di contatto</strong> alla fine della pagina.
            </Text>
          </HStack>
        </VStack>
      </Box>

      {/* Barra di ricerca */}
      <Box mb={4} mt={4} borderRadius={8} bg="white" boxShadow="md">
        <Input
          placeholder="Cerca una domanda..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          size="lg"
        />
      </Box>

      {/* Sezioni FAQ */}
      <VStack spacing={6} align="stretch">
        {filteredSections.map((section) => (
          <Box
            key={section.category}
            p={4}
            bg="white"
            borderRadius="md"
            boxShadow="md"
          >
            <HStack mb={4}>
              {section.icon}
              <Heading as="h2" size="md">
                {section.category}
              </Heading>
            </HStack>
            <Accordion allowToggle>
              {section.faqs.map((faq) => (
                <AccordionItem key={faq.question}>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      {faq.question}
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel pb={4}>{faq.answer}</AccordionPanel>
                </AccordionItem>
              ))}
            </Accordion>
          </Box>
        ))}
      </VStack>

      {/* CTA finale */}
      <Box mt={12} p={6} bg="white" borderRadius="md" boxShadow="md">
        <Heading as="h2" size="md" mb={4}>
          Non hai trovato quello che cercavi?
        </Heading>
        <Text mb={4}>
          Scrivici un messaggio e ti risponderemo al più presto!
        </Text>
        <form onSubmit={handleContactSubmit}>
          <FormControl mb={4} isRequired>
            <FormLabel>Email</FormLabel>
            <Input
              type="email"
              placeholder="La tua email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </FormControl>
          <FormControl mb={4} isRequired>
            <FormLabel>Messaggio</FormLabel>
            <Textarea
              placeholder="Il tuo messaggio"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </FormControl>
          <Button type="submit" colorScheme="blue" isLoading={isSending}>
            Invia Messaggio
          </Button>
        </form>
      </Box>
    </Box>
  );
};

export default FAQPage;
